import { firestore } from '../firebase'
import { MAILFOOTER } from 'config/actionTypes'
import { dispatch } from 'store'

const mailFooterREF = firestore.collection('settings').doc('mailFooter')

export const getEditorState = async () => {

    const mailFooterSNAP = await mailFooterREF.get()
    const mailFooter = mailFooterSNAP.data()
    if(mailFooter && mailFooter.editorState && mailFooter.editorState.length >3) {
        const { editorState, isActive, fileLinks } = mailFooter
        return dispatch({type: MAILFOOTER.INIT_EDITOR, payload: {isActive, editorState, fileLinks}})
    } else {
        const {isActive} = mailFooter
        return dispatch({type: MAILFOOTER.INIT_EDITOR, payload:{ isActive, editorState: '', fileLinks: [],}})
    }
}
export const watchMailFooter = () => {
    mailFooterREF.onSnapshot(snap=>{
        const mailFooter = snap.data()

        if(mailFooter && mailFooter.editorState && mailFooter.editorState.length>3) {
            return dispatch({type: MAILFOOTER.INIT_EDITOR, payload: {...mailFooter}})
        } else {
            const {isActive, recipients} = mailFooter
            return dispatch({type: MAILFOOTER.INIT_EDITOR, payload:{ isActive, editorState: '', fileLinks: [], recipients}})
        }
    })
}

export const saveEditorState = async (editorState, _isActive, fileLinks) => {
    if(editorState.length<10 && _isActive) {
        const isActive = false
        return mailFooterREF.update({isActive, editorState, fileLinks})
    }
    return mailFooterREF.update({editorState, fileLinks})
}

export const setMailFooterActive = async option => {
    //dispatch({type: MAILFOOTER.SET_ACTIVE, payload: option})
    return mailFooterREF.update({isActive: option})
}

export const setFileLinks = (fileLinks) => {
    return mailFooterREF.update({fileLinks})
}

export const setFooterRecipients = (recipients) =>{
    const allRecipientFalse = checkRecipients(recipients)
  
    if(allRecipientFalse)
        return mailFooterREF.update({recipients, isActive: false})
    return mailFooterREF.update({recipients})
}

const checkRecipients = (recipients) => {
    const a = !recipients.nachbarschaftshilfe.requester
    const b = !recipients.nachbarschaftshilfe.provider
    const c = !recipients.pflegekasse.requester
    const d = !recipients.pflegekasse.provider
    return a && b && c && d
}
